const Criteria = [];
const getCriteria = (state = Criteria, action) => {
    if(action.type === "SET_CRITERIA"){
        state =  action.criteria
    }
    return state;
}

export default getCriteria;